import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=0826ec72&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826ec72",
  null
  
)

export default component.exports